export default {"src":"/_next/static/media/discord.faca4d30.svg","height":20,"width":27};